export class ReactUtilities {
    public static ExecuteMethodPropIfDefined(action:(args?:any)=>void,args?:any)
    {
        if(typeof action!="undefined")
            action(args);
    }

    public static GetPropertyValue<T>(prop:T,propertyName:keyof T,defaultValue:any)
    {
        if(typeof prop[propertyName]!="undefined")
            return prop[propertyName];
        else
            return defaultValue;

    }
}